export class WidgetOptions {
    
    background = {
        colors: null
    };

    // bookmark
    uiBookmarkTour = false;

    // Misc
    uiAnnotations = false;
    uiAudio = false;
    uiInfo = true;
    uiLoadProgress = true;
    uiFullscreen = true;

    // Navigation
    uiZoom = true;
    uiCenter = true;
    uiCameraMode = true;

    // Scene
    uiObjectTree = false;
    uiObjectSlider = false;

    // Timeline
    uiPlayPause = false;
    uiScrubber = false;

    // Tools
    uiCrossSection = false;
    uiDissect = false;

    // View Modes
    uiIsolate = false;
    uiXray = false;

    // Actions
    uiActionsTour = false;

    uiShare = false;
    uiHelp = false;

    // BG logo
    uiBd: '' | 'no-link' | 'false' = '';

    // toolbar grouping: default = '' (grouped)
    uiToolsDisplay: '' | 'primary' = '';

    loadRotate: number = null;

    initial = {
        button: false,
        handHint: false
    };

    disableScroll = {
        alert: false,
        overlay: false
    };

}
